import { render, staticRenderFns } from "./YActAlertDialog.vue?vue&type=template&id=139e95b2&scoped=true"
import script from "./YActAlertDialog.vue?vue&type=script&lang=js"
export * from "./YActAlertDialog.vue?vue&type=script&lang=js"
import style0 from "./YActAlertDialog.vue?vue&type=style&index=0&id=139e95b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139e95b2",
  null
  
)

export default component.exports